export const centsToPrice = (cents) => {
  return `$${(cents / 100).toFixed(2)}`;
};

export const centsToPriceNoTrailingZeros = (cents) => {
  return `$${(cents / 100).toFixed()}`;
};
